import { TFunction } from 'i18next'
import { date, number, object, SchemaOf, string } from 'yup'

export interface VatDeclarationsRegisterPeriodPaymentModalForm {
  paymentAccount: string
  paymentDate: Date
  totalAmount: number
}

export type VatDeclarationsRegisterPeriodPaymentModalFormSchema =
  SchemaOf<VatDeclarationsRegisterPeriodPaymentModalForm>

export const getValidationSchema = (t: TFunction): VatDeclarationsRegisterPeriodPaymentModalFormSchema =>
  object({
    paymentAccount: string().required(t('vat_declarations.register_payment_modal.account_required')),
    paymentDate: date().required(t('vat_declarations.register_payment_modal.payment_date_required')),
    totalAmount: number().required(),
  })

export const getDefaultValues = (totalAmount: number): VatDeclarationsRegisterPeriodPaymentModalForm => ({
  paymentAccount: '',
  paymentDate: new Date(),
  totalAmount,
})
